import { Operation } from '../../../__generated__/globalTypes'

import {
  CampaignFragment,
  campaignFragmentString,
} from '../../fragments/__generated__/CampaignFragment'

import { sendDelayFragmentString } from '../../fragments/__generated__/SendDelayFragment'

import { campaignLineFragmentString } from '../../fragments/__generated__/CampaignLineFragment'

import { minimalPanelFragmentString } from '../../fragments/__generated__/MinimalPanelFragment'

import { giftVariationFragmentString } from '../../fragments/__generated__/GiftVariationFragment'

import { amountString } from '../../fragments/__generated__/Amount'

import { priceString } from '../../fragments/__generated__/Price'

import acceptCampaignShareRawString from '../AcceptCampaignShare.graphql'

const acceptCampaignShareString = [
  acceptCampaignShareRawString,
  campaignFragmentString,
  sendDelayFragmentString,
  campaignLineFragmentString,
  minimalPanelFragmentString,
  giftVariationFragmentString,
  amountString,
  priceString,
].join('\n\n')

export type AcceptCampaignShareData = {
  acceptCampaignShare: {
    campaign: CampaignFragment
  }
}

export type AcceptCampaignShareVariables = {
  id: string
}

export type AcceptCampaignShare = Operation<
  AcceptCampaignShareData,
  AcceptCampaignShareVariables
>

export const AcceptCampaignShare = ({
  id,
}: AcceptCampaignShareVariables): AcceptCampaignShare => ({
  query: acceptCampaignShareString,
  variables: {
    id,
  },
})
